(function () {
    registerNS("ep");
    ep.mouseWheelHelper = {
        deltaFactor: 40,

        getScrollDeltaY: function (event) {
            var direction = -event.deltaY;
            return this.deltaFactor * direction;
        },

        getScrollDeltaX: function (event) {
            var direction = -event.deltaX;
            return this.deltaFactor * direction;
        }
    };
})();